import React from 'react'
import { connect } from 'react-redux'
import { StyledRow } from '@bit/wavfichacerta.fichacerta.shared-styles.rows'
import { defaultEmail } from '@bit/wavfichacerta.fichacerta.fields-templates.email'
import { defaultPhoneWithoutDDI } from '@bit/wavfichacerta.fichacerta.fields-templates.phone'
import { simpleNonRequiredSelect } from '@bit/wavfichacerta.fichacerta.fields-templates.select'
import handler from '@bit/wavfichacerta.fichacerta.inputs-functions.input-handler'
import { text, maskedText, textDisabled, radio, select } from '@bit/wavfichacerta.fichacerta.inputs.inputs'
import { simpleDisabledText, simpleNonRequiredText } from '@bit/wavfichacerta.fichacerta.fields-templates.simple-text'
import { removeNonDigit } from '@bit/wavfichacerta.fichacerta.utils.normalizers'
import { validatePhone, validateWhatsappConfirmationField } from '../../../../utils/validations'
import { ContainerRadio } from './secondLine.styled'
import {
  alcadaLuciaColetaOptions,
  alcadaLuciaSolicitacaoOptions,
  hasAcessoLucia,
  isWhatsappCompartilhado,
  validateAlcadaLuciaColeta,
  validateAlcadaLuciaSolicitacao,
} from '../fields'
import { isLuciaColetaAtivada } from '../../../../utils/luciaColeta'

const phoneField = (required) => ({
  ...defaultPhoneWithoutDDI('telefone', 'Telefone', 'field-fc field-fc-xs field-fc-sm-4', required),
  validate: required
    ? validatePhone
    : (value) => (value ? validatePhone(value) : undefined),
})

const whatsappField = () => ({
  ...defaultPhoneWithoutDDI('whatsapp', 'Whatsapp', 'field-fc field-fc-xs field-fc-sm-4', true),
  validate: validatePhone,
})

const confirmWhatsappField = () => ({
  name: 'whatsapp_confirmation',
  label: 'Confirmar Whatsapp',
  isRequired: true,
  size: 'field-fc field-fc-xs field-fc-sm-4',
  type: 'maskedText',
  validate: validateWhatsappConfirmationField,
  normalize: removeNonDigit,
  placeholder: '(   ) _____-_____',
  props: {
    regex: [
      '(', /\d/, /\d/, ')',
      /\d/, /\d/, /\d/, /\d/, /\d/,
      '-',
      /\d/, /\d/, /\d/, /\d/
    ]
  }
})

const validateTelefoneRestrito = (value, allValues) => {
  if (!hasAcessoLucia(allValues)) {
    return undefined
  }

  if (value === undefined || value === null || value === '') {
    return 'Selecione o Tipo de Acesso LucIA'
  }

  return undefined
}

const tipoAcessoLuciaField = () => ({
  name: 'restrito',
  label: 'Tipo de Acesso LucIA:',
  isRequired: true,
  size: 'field-fc field-fc-xs field-fc-sm-4',
  type: 'radio',
  direction: 'row',
  validate: validateTelefoneRestrito,
  options: [
    { label: 'Whatsapp Restrito', value: '1' },
    { label: 'Whatsapp Compartilhado', value: '0' },
  ],
})

const alcadaLuciaField = (whatsappCompartilhado) => ({
  ...simpleNonRequiredSelect({ size: 'field-fc field-fc-xs field-fc-sm-4', name: 'alcada_lucia', label: 'Alçada LucIA Solicitação' }),
  options: alcadaLuciaSolicitacaoOptions(whatsappCompartilhado),
  validate: validateAlcadaLuciaSolicitacao,
})

const alcadaLuciaColetaField = (whatsappCompartilhado) => ({
  ...simpleNonRequiredSelect({ size: 'field-fc field-fc-xs field-fc-sm-4', name: 'alcada_lucia_coleta', label: 'Alçada LucIA Coleta' }),
  options: alcadaLuciaColetaOptions(whatsappCompartilhado),
  validate: validateAlcadaLuciaColeta,
})

export default connect((state) => ({
  luciaColetaAtivada: isLuciaColetaAtivada(state.login?.user?.usuario?.lucia_coleta_ativada),
  luciaSolicitaDisponivel: state.login?.user?.usuario?.lucia_solicita_disponivel === true,
  luciaColetaDisponivel: isLuciaColetaAtivada(state.login?.user?.usuario?.lucia_coleta_ativada)
    && state.login?.user?.usuario?.lucia_coleta_disponivel === true,
}))((props) => {
  const {
    editMode,
    typeUserEdit,
    typeUser,
    loggedUser,
    changedValues,
    luciaColetaAtivada = false,
    luciaSolicitaDisponivel = false,
    luciaColetaDisponivel = false,
  } = props;
  const acessoLucia = hasAcessoLucia(changedValues) && luciaSolicitaDisponivel
  const whatsappCompartilhado = isWhatsappCompartilhado(changedValues)
  const showColetaAlcada = luciaColetaAtivada && luciaColetaDisponivel

  const creditAndTotal = (
    <>
      {typeUser === "MASTER" && !editMode && (handler({ text })(simpleNonRequiredText({ size: 'field-fc field-fc-xs field-fc-sm-4', name: 'credit', label: 'Limite disponível' })))}
      {handler({ textDisabled })(simpleDisabledText({ size: 'field-fc field-fc-xs field-fc-sm-4', name: 'total', label: 'Total' }))}
    </>
  )

  if (editMode && typeUserEdit === "MASTER" && !loggedUser) {
    return (
      <>
        <StyledRow justify="flex-start" margin="3rem 0 0 0" className='secondLineFields'>
          {handler({ text })(defaultEmail('field-fc field-fc-sm field-fc-sm-8'))}
          {handler({ maskedText })(phoneField(true))}
          {creditAndTotal}
        </StyledRow>
        {acessoLucia && (
          <StyledRow justify="flex-start" margin="1.5rem 0 0 0" className='luciaAccessFields'>
            <ContainerRadio>
              {handler({ radio })(tipoAcessoLuciaField())}
            </ContainerRadio>
            {handler({ select })(alcadaLuciaField(whatsappCompartilhado))}
            {showColetaAlcada && handler({ select })(alcadaLuciaColetaField(whatsappCompartilhado))}
          </StyledRow>
        )}
        {acessoLucia && (
          <StyledRow justify="flex-start" margin="1.5rem 0 0 0" className='whatsappFields'>
            {handler({ maskedText })(whatsappField())}
            {handler({ maskedText })(confirmWhatsappField())}
          </StyledRow>
        )}
      </>
    );
  }

  return (
    <>
      <StyledRow justify="flex-start" margin="3rem 0 0 0" className='secondLineFields'>
        {handler({ text })(defaultEmail('field-fc field-fc-sm field-fc-sm-8'))}
        {handler({ maskedText })(phoneField(true))}
        {creditAndTotal}
      </StyledRow>
      {acessoLucia && (
        <StyledRow justify="flex-start" margin="1.5rem 0 0 0" className='luciaAccessFields'>
          <ContainerRadio>
            {handler({ radio })(tipoAcessoLuciaField())}
          </ContainerRadio>
          {handler({ select })(alcadaLuciaField(whatsappCompartilhado))}
          {showColetaAlcada && handler({ select })(alcadaLuciaColetaField(whatsappCompartilhado))}
        </StyledRow>
      )}
      {acessoLucia && (
        <StyledRow justify="flex-start" margin="1.5rem 0 0 0" className='whatsappFields'>
          {handler({ maskedText })(whatsappField())}
          {handler({ maskedText })(confirmWhatsappField())}
        </StyledRow>
      )}
    </>
  );
})
